/**
 * Mapbox popup
 * 
 * @Author: Focci
 * @Date: 2023-07-12 17:06:59
 * @Last Modified by: Focci
 * @Last Modified time: 2023-07-12 17:06:59
 */

// import PropTypes from 'prop-types'
import { useMapState } from '@comp/mapbox'
import { useMap } from 'react-map-gl'
import CustomPopup from './CustomPopup'
import FacilityContent from './FacilityContent'
import PropertyPopupContent from './PropertyPopupContent'
import SchoolPopupContent from './SchoolPopupContent'
import BusStopContent from './BusStopContent'

function PopupContent({ type, data, events }) {
  if(type === 'school') {
    return <SchoolPopupContent schoolId={data.id} events={events} />
  }

  if(type === 'facility') {
    return <FacilityContent data={data} />
  }

  if(type === 'busStop') {
    return <BusStopContent data={data} />
  }

  return <PropertyPopupContent type={type} point={data} />
}

// 判断点是否在可视区域内
export function checkInBounds({ lng, lat }, mapbox) {
  let pass = false
  try {
    const pt = [lng, lat]
    const bounds = mapbox.getBounds()

    pass = bounds.contains(pt)
  } catch(err) { /**/ }
  
  return pass
}

export default function MapboxPopup() {
  const { popups, setPopups, events } = useMapState()
  const { current: mapbox } = useMap()

  return popups.map(({ type, popupProps, data }) => {
    if(!(data && checkInBounds(data, mapbox))) {
      return null
    }
    
    return (
      <CustomPopup
        key={`key-${data.lng}${data.lat}`}
        data={data}
        popupProps={popupProps}
        onClose={() => setPopups([])}
      >
        <PopupContent type={type} data={data} events={events} />
      </CustomPopup>
    )
  })
}

// MapboxPopup.propTypes = {
//   mapboxState: PropTypes.object.isRequired,
// }
